import React from 'react';

const DollarSign = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 20 20">
      <path
        fill="currentColor"
        d="M2.93 2.93c3.904-3.906 10.235-3.906 14.14 0 3.906 3.904 3.906 10.235 0 14.14-3.905 3.906-10.236 3.906-14.14 0-3.906-3.905-3.906-10.236 0-14.14zm12.855 1.285c-3.195-3.196-8.375-3.196-11.57 0-3.196 3.195-3.196 8.375 0 11.57 3.195 3.196 8.375 3.196 11.57 0 3.196-3.195 3.196-8.375 0-11.57zM10 4.058c.502 0 .909.407.909.909v.349c1.119.383 1.969 1.476 2.05 2.674.037.54-.314 1.043-.89 1.043-.501 0-.909-.407-.909-.909 0-.627-.509-1.136-1.136-1.136-.424 0-.721.318-.806.714-.243 1.127 1.062 1.431 1.847 1.777.404.178.79.406 1.11.712 1.337 1.274.715 3.446-.795 4.284-.108.06-.22.113-.334.157l-.138.046v.355c0 .466-.35.85-.802.903l-.106.006c-.502 0-.91-.407-.91-.91v-.346c-1.18-.397-2.004-1.566-2.052-2.864.029-.475.415-.856.899-.856.502 0 .909.407.909.91 0 .626.509 1.136 1.136 1.136.166 0 .323-.039.466-.107.44-.208.619-.67.504-1.013-.178-.537-.77-.759-1.253-.961-.292-.123-.59-.251-.876-.399-.828-.425-1.543-1.098-1.717-2.047-.128-.698.069-1.415.459-1.999.367-.55.91-.955 1.525-1.161v-.358c0-.502.408-.91.91-.91z"
      />
    </svg>
  );
};

export default DollarSign;
